"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferAction = exports.DevestingAction = exports.Multisig = void 0;
var schema_1 = require("@solvei/borsh/schema");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var Multisig = /** @class */ (function () {
    function Multisig(properties) {
        if (properties) {
            this.is_initialized = properties.is_initialized;
            this.require_signers = properties.require_signers;
            this.require_numbers = properties.require_numbers;
            this.account_to_transfer = properties.account_to_transfer;
        }
    }
    Multisig.space = 387;
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], Multisig.prototype, "is_initialized", void 0);
    __decorate([
        (0, schema_1.field)([utils_1.PublicKeyCreator, constants_1.MAX_SIGNERS])
    ], Multisig.prototype, "require_signers", void 0);
    __decorate([
        (0, schema_1.field)(["u8", constants_1.MULTISIG_OPERATIONS])
    ], Multisig.prototype, "require_numbers", void 0);
    __decorate([
        (0, schema_1.field)(utils_1.PublicKeyCreator)
    ], Multisig.prototype, "account_to_transfer", void 0);
    return Multisig;
}());
exports.Multisig = Multisig;
var DevestingAction = /** @class */ (function () {
    function DevestingAction(properties) {
        if (properties) {
            this.is_initialized = properties.is_initialized;
            this.require_signers = properties.require_signers;
            this.devesting_account_pubkey = properties.devesting_account_pubkey;
        }
    }
    DevestingAction.space = 45;
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], DevestingAction.prototype, "is_initialized", void 0);
    __decorate([
        (0, schema_1.field)(["u8", constants_1.MAX_SIGNERS])
    ], DevestingAction.prototype, "require_signers", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], DevestingAction.prototype, "action_enum", void 0);
    __decorate([
        (0, schema_1.field)(utils_1.PublicKeyCreator)
    ], DevestingAction.prototype, "devesting_account_pubkey", void 0);
    return DevestingAction;
}());
exports.DevestingAction = DevestingAction;
var TransferAction = /** @class */ (function () {
    function TransferAction(properties) {
        if (properties) {
            this.is_initialized = properties.is_initialized;
            this.require_signers = properties.require_signers;
            this.amounts = properties.amounts;
            this.accounts_to_transfers = properties.accounts_to_transfers;
        }
    }
    TransferAction.space = 453;
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], TransferAction.prototype, "is_initialized", void 0);
    __decorate([
        (0, schema_1.field)(["u8", constants_1.MAX_SIGNERS])
    ], TransferAction.prototype, "require_signers", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], TransferAction.prototype, "action_enum", void 0);
    __decorate([
        (0, schema_1.field)(["u64", constants_1.MAX_SIGNERS])
    ], TransferAction.prototype, "amounts", void 0);
    __decorate([
        (0, schema_1.field)([utils_1.PublicKeyCreator, constants_1.MAX_SIGNERS])
    ], TransferAction.prototype, "accounts_to_transfers", void 0);
    return TransferAction;
}());
exports.TransferAction = TransferAction;
//# sourceMappingURL=models-devesting.js.map